import React from 'react'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
function Profile({width}) {
  
  const user_id = localStorage.getItem('dastaan__user_id') ? localStorage.getItem('dastaan__user_id') : 0;
  return (
    <Container className={`profile-container ${width > 768 ? 'ml-10' :''}`} style={{}}>
      <Row className='d-block d-md-none'>
        <Col sm={12} xs={12} md={12} className='text-center'>
          <div className='user_name'>
            <Image
              src={`${process.env.PUBLIC_URL}/player_icons/profile.svg`}
            />
          </div>
        </Col>
        {
          user_id > 0 && (
            <>
              <Col sm={12} xs={12} md={12} className=' text-center mt-2'>
                <div className='user_contact'>+91 {localStorage.getItem('dastaan__phone')}
                </div>
              </Col>
              <Col sm={12} xs={12} md={12} className='text-center mt-5'>
                <Link to="/plans"><span className='upgrade_btn'>Upgrade Plan</span></Link>
              </Col>
            </>
          )
        }
      </Row>
      <Row className='mt-2 d-xs-none desktop'>
        <Col sm={2} xs={2} md={2}>
          <div className='user_name'>
            <Image
              src={`${process.env.PUBLIC_URL}/player_icons/profile.svg`}
            />
          </div>
        </Col>
        {
          user_id > 0 && (
            <Col sm={6} xs={6} md={6} className='mt-2'>
              <Row>
                <Col sm={6} md={6} lg={6}>
                  <div className='user_contact'>+91 {localStorage.getItem('dastaan__phone')}</div>
                </Col>
              </Row>
              <Row>
                {/* <Col sm={6} xs={6} md={6} className='mt-2 mb-3'>
                  <Link to="/plans"><span className='upgrade_btn'>Upgrade Plan</span></Link>
                </Col> */}
              </Row>
            </Col>
          )
        }
      </Row>
    </Container>
  )
}
export default Profile